<template>
  <div>
    <v-row class="mt-2" v-if="loading || loadingEtapas">
      <v-col cols="12" sm="2" md="2" lg="2" v-for="i in 6" :key="i">
        <v-skeleton-loader type="text" class="mb-3"></v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row class="ui-etapas my-4" no-gutters v-if="!loading && !loadingEtapas && !!etapas && etapas.length > 0">
        <v-col v-ripple
          v-for="(item, index) in etapas"
          :key="index"
          @click="alteraEtapa(index)"
          class="d-flex justify-center align-center"
          :class="[
            ($vuetify.theme.dark ? 'dark-etapas' : 'white-etapas'),
            (item.fet_id === etapaAtual.fet_id || index <= indexEtapaAtual ? 'ui-etapas-ativo' : '')
          ]">
          <div class="text text-center col-11">
            {{item.fet_nome}}
          </div>
        </v-col>
      </v-row>
  </div>
</template>

<script>
import Api from '@API'

export default {
  props: ['status', 'etapasAtuais', 'uuidOportunidade'],
  data () {
    return {
      funis: [],
      funil: null,
      loading: false,
      loadingEtapas: false,
      etapas: [],
      etapasOportunidade: [],
      etapaAtual: null,
      indexEtapaAtual: 0,
      itens_funil: [
        {
          id: 1,
          nome: 'Nova oportunidade',
          concluido: true,
          cor: '#CB0808'
        },
        {
          id: 2,
          nome: 'Geração de proposta',
          concluido: false,
          cor: '#FF5C00'
        },
        {
          id: 3,
          nome: 'Proposta enviada',
          concluido: false,
          cor: '#DCD300'
        },
        {
          id: 4,
          nome: 'Negociação',
          concluido: false,
          cor: '#00B01A'
        },
        {
          id: 5,
          nome: 'Fechamento',
          concluido: false,
          cor: '#004A93'
        }
      ]
    }
  },
  methods: {
    async alteraEtapa (indexEtapa) {
      if (indexEtapa !== 0 && indexEtapa === this.indexEtapaAtual) --indexEtapa

      const dados = [{
        uuid_fun_id: this.funil,
        uuid_fet_id: this.etapas[indexEtapa].uuid_fet_id,
        uuid_opu_id: this.uuidOportunidade
      }]

      const etapaAlterada = {etapas: dados}
      const { status } = await Api.post('oportunidades/altera/etapas', etapaAlterada)
      if (status !== 200) {
        console.log(status, 'status')
        this.$root.SnackControl.open(this, {
          text: 'Ops, ocorreu um erro ao alterar a etapa desta oportunidade!',
          color: 'error'
        })
      } else {
        this.etapaAtual = this.etapas[indexEtapa].uuid_fet_id
        this.indexEtapaAtual = indexEtapa
      }
    },
    async getFunis () {
      this.loading = true
      await Api.get('funis')
        .then(res => {
          if (res.data && res.data.length > 0) {
            this.funis = res.data
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os funis!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getEtapas () {
      if (this.funis.length === 0) return

      this.loadingEtapas = true

      this.funil = this.funis[0].uuid_fun_id
      if (this.status === 3) {
        this.funil = this.funis[1].uuid_fun_id
      }

      const endpoint = `funis/etapas/funil/${this.funil}?oportunidade=${this.uuidOportunidade}`
      await Api.get(endpoint)
        .then(async res => {
          if (res.data) {
            this.etapas = res.data
            await this.setaEtapaAtual()
          }
          this.loadingEtapas = false
        })
        .catch(err => {
          console.log(err)
          this.loadingEtapas = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os dados!',
            color: 'error'
          })
        })
    },
    setaEtapaAtual () {
      if (!this.etapasOportunidade || this.etapasOportunidade.length === 0 || !this.etapas || this.etapas.length === 0) return

      const funilAtual = this.status === 1 ? 1 : 2
      let etapaAtual = null

      this.etapasOportunidade.map(etapa => {
        if (etapa.fk_fun_id_funil === funilAtual) etapaAtual = etapa
      })

      this.etapas.map((etapa, index) => {
        if (etapa.fet_id === etapaAtual.fet_id) {
          this.etapaAtual = etapa
          this.indexEtapaAtual = index
        }
      })
    },
    async loadFunctions () {
      await this.getFunis()
      await this.getEtapas()
    }
  },
  created () {
    if (this.etapasAtuais) this.etapasOportunidade = this.etapasAtuais
    this.loadFunctions()
  }
}
</script>
<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
</style>



// WEBPACK FOOTER //
// src/pages/oportunidades/EtapasOportunidade.vue